import { render, staticRenderFns } from "./ObjectiuCrud.vue?vue&type=template&id=14e31ef4&scoped=true&"
import script from "./ObjectiuCrud.vue?vue&type=script&lang=js&"
export * from "./ObjectiuCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e31ef4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
